export const slackMethod = {
  authenticationWithSlack: 'auth-with-slack',
  linkingWithSlack: 'link-with-slack',
  loginWithSlack: 'login-with-slack',
  addToSlack: 'add-to-slack',
};
